import { wsApiHost } from "..";


export const initializeChatWS = (setMessages, setChatWs, userId) => {
    
    try {
      const websocket = new WebSocket(wsApiHost + '/ws/chat/');
      setChatWs(websocket);
      websocket.onopen = () => {
        console.log(`Connected to chat WS`);
      };

      websocket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.action === 'get_messages'){
            setMessages([]);
            setMessages(data.messages);
        }
        else if (data.action === 'new_message'){
            if (data.message.user.id !== userId) {
                setMessages(prevMessages => [data.message, ...prevMessages]);
            }
        }
        };
        websocket.onclose = (event) => {
          console.log("Websocket closed")  
          setChatWs(null);
        };
      
    } catch (error) {
    //   initializeChatWS(messages, setMessages, chatWs, setChatWs, userId);
        
    }
  };
